<template>
  <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.02979 3.93652L8.24854 2.78809H6.70361L7.24365
    0.135742H6.07471L5.52783 2.78809H3.61377L4.14697 0.135742H2.97803L2.43115
    2.78809H1.04346L0.811035 3.93652H2.19873L1.76807 6.08301H0.29834L0.0795898
    7.24512H1.52881L0.975098 10H2.14404L2.69775 7.24512H4.62549L4.06494 10H5.24072L5.79443
    7.24512H7.27783L7.50342 6.08301H6.02686L6.46436 3.93652H8.02979ZM3.34033
    3.88867H5.34326L4.88525 6.14453H2.88232L3.34033 3.88867Z" fill="#AEAEAE"/>
  </svg>
</template>

<script>
export default {
  name: 'HashTag'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Main/Icons/HashTag.vue